// import { logEvent } from '@firebase/analytics';
// import { firebaseAnalytics } from '../firebase';
import getTimezone from '../timezone';
import { queueReportOther } from './reportQueue';
import type { EBiz } from './report_biz';
import type { ReportKeys } from './type';

// 通过 枚举 限定上报的 key，方便管理
export enum EReportOtherKey {
  other = 'other', // 应有的注释

  activity = 'activity', // 上报活跃度

  timer_open_session = 'timer_open_session', // 开启session的耗时
  restart_open_session = 'restart_open_session', // 重启 session
  continue_open_session = 'continue_open_session', // 续接老的session
  timer_receive_message = 'timer_receive_message', // 发送到接收消息的耗时
  timer_receive_hint_message = 'timer_receive_hint_message', // 发送到接收提示消息的耗时
  timer_receive_final_message = 'timer_receive_final_message', // 发送到接收最终消息的耗时
  timer_receive_ending_duration = 'timer_receive_ending_duration', // -1消息与上一条消息的间隔时间
  timer_send_msg = 'timer_send_msg', // 发送消息的时间

  cos_upload_success = 'cos_upload_success',
  cos_upload_fail = 'cos_upload_fail',

  chat_receive_sub_code = 'chat_receive_sub_code', // 收到 subCode

  canvas_open_duration = 'canvas_open_duration', // 打开 canvas 的耗时

  offer_share_expose = 'offer_share_expose', // offer 分享曝光
  offer_play_click = 'offer_play_click', // offer 播放点击
  offer_play_end = 'offer_play_end', // offer 播放结束
  offer_remix_click = 'offer_remix_click', // offer remix 点击
  offer_submit_click = 'offer_submit_click', // offer 提交点击
  offer_create_expose = 'offer_create_expose', // offer 创建曝光
  offer_preview_click = 'offer_preview_click', // offer 预览点击
  offer_remix_output_expose = 'offer_remix_output_expose', // offer remix 输出曝光
  offer_share_to_others_click = 'offer_share_to_others_click', // offer 分享到他人点击

  rizz_share_expose = 'rizz_share_expose', // rizz 分享曝光
  rizz_play_click = 'rizz_play_click', // rizz 播放点击
  rizz_play_end = 'rizz_play_end', // rizz 播放结束
  rizz_remix_click = 'rizz_remix_click', // rizz remix 点击
  rizz_submit_click = 'rizz_submit_click', // rizz 提交点击
  rizz_create_expose = 'rizz_create_expose', // rizz 创建曝光
  rizz_preview_click = 'rizz_preview_click', // rizz 预览点击
  rizz_remix_output_expose = 'rizz_remix_output_expose', // rizz remix 输出曝光
  rizz_share_to_others_click = 'rizz_share_to_others_click' // rizz 分享到他人点击
}

export default function reportOther(key: EReportOtherKey, params?: ReportKeys, biz?: EBiz): void {
  const searchParams = new URLSearchParams(window.location.search);
  const timezone = getTimezone();

  // 为了以防万一，默认使用 key10 填写 biz 的值，防止被占用
  const newParams: ReportKeys = {
    key10: biz,
    ...(timezone ? { timezone } : {}),
    ...(searchParams.get('utm_source')
      ? { utm_source: searchParams.get('utm_source') || undefined }
      : {}),
    ...(searchParams.get('utm_medium')
      ? { utm_medium: searchParams.get('utm_medium') || undefined }
      : {}),
    ...(searchParams.get('utm_campaign')
      ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
      : {}),
    ...(params || {})
  };

  queueReportOther(key, newParams);
  // 上报到 firebase
  // logEvent(firebaseAnalytics(), key as string, newParams);
}
